import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Login from "../Login/Login";
import "../App.css";
import { Error } from "../Generic/404";
import MachineRoute from "../Routing/MachineRoute";
import MachineSelect from "../Landing/MachineSelect";
import FoodMaking from "../Kiosk/FoodMaking";
import ManualControl from "../ManualControl/ManualControl";
import Inventory from "../Inventory/Inventory";
import "react-toastify/dist/ReactToastify.css";
import OtherRoute from "../Routing/OtherRoute";
import { SwitchTransition, CSSTransition } from "react-transition-group";
import RecentOrders from "../Orders/RecentOrders";
import OrderDetails from "../Orders/OrderDetails";
import Task from "../Tasks/Task";
import TaskList from "../Tasks/TaskList";
import Replenish from "../Inventory/Replenish";
import KitchenModules from "../Kiosk/KitchenModules";
import { AppRoutes } from "../config/app.config";
import GodMode from "../Kiosk/GodMode";
import ActiveTasks from "../Tasks/ActiveTasks";
import StudioRoute from "../Routing/StudioRoute";
import IngredientDetails from "../CookBook/Ingredients/IngredientDetails";
import IngredientList from "../CookBook/Ingredients/IngredientList";
import IngredientEdit from "../CookBook/Ingredients/IngredientEdit";
import IngredientCreate from "../CookBook/Ingredients/IngredientCreate";
import RecipeCreate from "../CookBook/Recipes/RecipeCreate";
import RecipeDetails from "../CookBook/Recipes/RecipeDetails";
import RecipeList from "../CookBook/Recipes/RecipeList";
import RecipeEdit from "../CookBook/Recipes/RecipeEdit";
import XookeeperPlannedTasks from "../Operations/Xookeeper/plannedTasks";
import XookeeperPastTasks from "../Operations/Xookeeper/pastTasks";
import SearchTasks from "../Tasks/SearchTasks";

const DashboardRoutes = ({ isLoggedIn = false }) => {
    const location = useLocation();
	return (
		<SwitchTransition>
			<CSSTransition
				//To animate only the parent routes and not the nested routes
				key={location.pathname.split("/")[1]}
				timeout={300}
				classNames="page"
				unmountOnExit>
				<Routes location={location} static>
					{/* Routes without auth */}
					<Route path="*" element={<Error />} />
					<Route path="/404" element={<Error />} />
					<Route path="/login" element={<Login />} />
					{/* Routes that don't need Header or Sidebar */}
					<Route path="/" element={<OtherRoute login={isLoggedIn} />}>
						<Route path="" element={<MachineSelect />} exact />
					</Route>
					{/* Routes with Header and Sidebar */}
					<Route path={AppRoutes.STUDIO.DEFAULT} element={<StudioRoute login={isLoggedIn} end />}>
						<Route path={AppRoutes.STUDIO.INGREDIENT_DETAILS} element={<IngredientDetails />} exact />
						<Route path={AppRoutes.STUDIO.INGREDIENT_LIST} element={<IngredientList />} exact />
						<Route path={AppRoutes.STUDIO.INGREDIENT_EDIT} element={<IngredientEdit />} exact />
						<Route path={AppRoutes.STUDIO.INGREDIENT_CREATE} element={<IngredientCreate />} exact />
						<Route path={AppRoutes.STUDIO.RECIPE_CREATE} element={<RecipeCreate />} exact />
						<Route path={AppRoutes.STUDIO.RECIPE_DETAILS} element={<RecipeDetails />} exact />
						<Route path={AppRoutes.STUDIO.RECIPE_LIST} element={<RecipeList />} exact />
						<Route path={AppRoutes.STUDIO.RECIPE_EDIT} element={<RecipeEdit />} exact />
					</Route>
					<Route path="/:machineId/*" element={<MachineRoute login={isLoggedIn} end />}>
						<Route path={AppRoutes.KIOSK.FOODMAKING} element={<FoodMaking />} exact />
						<Route path={AppRoutes.KIOSK.KITCHEN_MODULES} element={<KitchenModules />} exact />
						<Route path={AppRoutes.KIOSK.GOD_MODE} element={<GodMode />} exact />
						{/* <Route path={AppRoutes.KIOSK.LIVE_STREAM} element={<LiveFeed />} exact /> */}
						<Route path={AppRoutes.KIOSK.FOODMAKING} element={<FoodMaking />} exact />
						<Route path={AppRoutes.KIOSK.GOD_MODE} element={<ManualControl />} exact />
						<Route path={AppRoutes.TASKS.RECENT_TASKS} element={<TaskList />} exact />
						<Route path={AppRoutes.TASKS.TASK} element={<Task />} exact />
						<Route path={AppRoutes.TASKS.ACTIVE_TASKS} element={<ActiveTasks />} exact />
						<Route path={AppRoutes.TASKS.SEARCH_TASKS} element={<SearchTasks />} exact />
						<Route path={AppRoutes.INVENTORY.INVENTORY_SNAPSHOT} element={<Inventory />} exact />
						<Route path={AppRoutes.INVENTORY.REPLENISH} element={<Replenish />} exact />
						<Route path={AppRoutes.ORDERS.RECENT_ORDERS} element={<RecentOrders />} exact />
						<Route path={AppRoutes.ORDERS.ORDER_DETAILS} element={<OrderDetails />} exact />
						<Route path={AppRoutes.OPERATIONS.XOOKEEPER_PLANNED_TASKS} element={<XookeeperPlannedTasks />} exact />
						<Route path={AppRoutes.OPERATIONS.XOOKEEPER_PAST_TASKS} element={<XookeeperPastTasks />} exact />
						<Route path="*" element={<Error />} />
					</Route>
				</Routes>
			</CSSTransition>
		</SwitchTransition>
	);
};

export default DashboardRoutes;
